import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import axios from 'axios';
import _ from 'lodash';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { SubmissionError } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Form, DropdownButton, MenuItem, InputGroup, Input } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import InputField from '../Common/inputField';
import Selection from '../Common/selection';
import ReactDOM from 'react-dom';
import { Translate, Localize } from 'react-redux-i18n';
import FilterByStart from '../Common/filterByStart';

var ESCAPE_KEY = 27;
var ENTER_KEY = 13;

class SalesInventoryInfo extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      sortColumn: null,
      sortDirection: null,
      clickedCell: {row: 0, column: -1}
    }
    this.onCellSelected = this.onCellSelected.bind(this);
  }

  handleKeyDown(event) {
      switch( event.keyCode ) {
          case ESCAPE_KEY:
              this.props.closeShowInventory('productSearch');
              break;
          default:
              break;
      }
  }

  componentWillMount() {
    document.addEventListener("keydown", this.handleKeyDown.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown.bind(this));
  }

  componentDidMount() {
    this.props.setAllProductQuantity(1);
    console.log('this.props', this.props);
    this.props.fetchSalesInventoryInfo(this.props.Customer_id, this.props.SearchType, this.props.SearchValue)
    ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
  }

  handleFormSubmit(formProps) {

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.salesInventoryInfo && nextProps.salesInventoryInfo != this.props.salesInventoryInfo) {
      var rows = [...nextProps.salesInventoryInfo];
      this.setState({ rows });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.salesInventoryInfo && prevProps.salesInventoryInfo != 0 && prevProps.salesInventoryInfo != this.props.salesInventoryInfo) {
      ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
    }
  }

  onCellSelected(coordinates) {
    var clickedCell = {
      row: coordinates.rowIdx,
      column: coordinates.idx -1
    };
    this.setState({ clickedCell });
  }

  renderTable() {
      if (this.props.salesInventoryInfoIsLoading && !this.props.salesInventoryInfoError) return <Spinner/>
      else if (this.props.salesInventoryInfoError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.salesInventoryInfoError)}</div></ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          const onDoubleClick = rowProps => {
            if (this.props.inventoryItemTwo == true) {
              this.props.selectInventoryInfo(rowProps);
              this.props.closeShowInventory('quantity');
              return;
            }

            if (this.props.formName) {
              if (this.props.formName === 'favoriteList') {
                this.props.selectInventoryInfo(rowProps);
                this.props.closeShowInventory('quantity');
                return;
              }
              this.props.selectInventoryInfo(rowProps);
              // this.props.setSaleRowValue(`${rowProps.ProductNum} | ${rowProps.Name} | ${rowProps.Description}`, this.props.formName, rowProps);
              this.props.setSaleRowValue(`${rowProps.ProductNum} | ${rowProps.Name} | ${rowProps.Description}`, this.props.formName, rowProps);
              this.props.closeShowInventory('quantity');
            } else if (this.props.Customer_id != 0) {
              this.props.selectInventoryInfo(rowProps);
              this.props.setSaleRowValue(`${rowProps.ProductNum} | ${rowProps.Name} | ${rowProps.Description}`, 'salesOrderForm', rowProps);
              this.props.fetchItemSalesHistory(this.props.Customer_id, rowProps.Product_id);
              this.props.closeShowInventory('quantity');
            } else {
              this.props.selectInventoryInfo(rowProps);
              this.props.setPromoRowValue(`${rowProps.ProductNum} | ${rowProps.Name} | ${rowProps.Description}`, 'promotionForm');
              this.props.closeShowInventory('quantity');
            }
          }

          var RowRenderer = React.createClass({

           PropTypes: {
             onDoubleClick: React.PropTypes.func
           },

           render: function() {
             return (<div onDoubleClick={ ()=>{ this.props.onDoubleClick(this.props.row) } } ><ReactDataGrid.Row ref="row" {...this.props} /></div>)
           }
          });

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
              this.setState(state);
          }

          // Handle the row select function

          const onRowSelect = rows => {
              this.setState({ selectedRows: rows });
          }

          const onKeyDown = (e) => {
             if (e.keyCode === ENTER_KEY) {

              e.preventDefault();
              var rows = this.state.rows;
              var row = rows[this.state.clickedCell.row];

              if (this.props.inventoryItemTwo == true) {
                this.props.selectInventoryInfo(row);
                this.props.closeShowInventory('quantity');
                return;
              }

              if (this.props.formName) {
                if (this.props.formName === 'favoriteList') {
                  this.props.selectInventoryInfo(row);
                  this.props.closeShowInventory('quantity');
                  return;
                }
                this.props.selectInventoryInfo(row);
                this.props.setSaleRowValue(`${row.ProductNum} | ${row.Name} | ${row.Description}`, this.props.formName, row);
                // this.props.setSaleFavoriteRowValue(`${row.ProductNum} | ${row.Name} | ${row.Description}`, this.props.formName, row);
                this.props.closeShowInventory('quantity');
              } else if (this.props.Customer_id != 0) {
                this.props.selectInventoryInfo(row);
                this.props.setSaleRowValue(`${row.ProductNum} | ${row.Name} | ${row.Description}`, 'salesOrderForm', row);
                this.props.fetchItemSalesHistory(this.props.Customer_id, row.Product_id);
                this.props.closeShowInventory('quantity');
              } else {
                this.props.selectInventoryInfo(row);
                this.props.setPromoRowValue(`${row.ProductNum} | ${row.Name} | ${row.Description}`, 'promotionForm', row);
                this.props.closeShowInventory('quantity');
              }
            }
              // else if (e.keyCode === 27) {
              //   e.preventDefault();
              //   this.props.closeShowInventory('productSearch');
              // }
          }

          const columns = [
            {
                key: 'ProductNum',
                name: <Translate value="prod_num" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterRenderer: FilterByStart,
            },
            {
                key: 'RefNum',
                name: <Translate value="ref_num" />,
                resizable: true,
                sortable: true,
                width: 70,
                filterable: true,
                filterRenderer: FilterByStart,
            },
            {
                key: 'Name',
                name: <Translate value="prod_name" />,
                resizable: true,
                sortable: true,
            },
            {
                key: 'Description',
                name: <Translate value="desc" />,
                resizable: true,
                sortable: true,
            },
            {
                key: 'Price',
                name: <Translate value="unit_dollarsign" />,
                resizable: true,
                sortable: true,
                width: 70,
            },
            {
                key: 'MeasureUnit',
                name: <Translate value="pkg_type" />,
                resizable: true,
                sortable: true,
                width: 80,
            },
            {
                key: 'InStock',
                name: <Translate value="instock" />,
                resizable: true,
                sortable: true,
                width: 80,
            },
            {
                key: 'Purchased',
                name: <Translate value="purchased" />,
                resizable: true,
                sortable: true,
                width: 100,
            },
            {
                key: 'PreSale',
                name: <Translate value="presale" />,
                resizable: true,
                sortable: true,
                width: 80,
            },
          ]

          return (
              <Row><Col sm={ 12 }><div id="SalesInventoryInfo-dataGrid1">
                  <ReactDataGrid
                      ref="inventoryInfo"
                      rowKey='Product_id'
                      rowHeight={25}
                      minHeight={600}
                      onGridSort={handleGridSort}
                      headerRowHeight={45}
                      columns={columns}
                      rowGetter={rowGetter}
                      rowsCount={getSize() }
                      enableCellSelect={true}
                      rowRenderer={<RowRenderer onDoubleClick={onDoubleClick} />}
                      onGridKeyDown={onKeyDown}
                      onCellSelected={this.onCellSelected}
                  />
              </div></Col></Row>
          )
      }
  }

  render() {
    return (
      <ContentWrapper>
        {this.renderTable()}
      </ContentWrapper>
    )
  }
}

export default SalesInventoryInfo;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesInventoryInfo.jsx